import RouteView from "@/layouts/RouteView.vue";
export default {
  path: "/order",
  name: "Order",
  redirect: "/order/page",
  component: RouteView,
  meta: {
    title: "订单管理",
    showNavBar: false,
  },
  children: [
    {
      path: "/order/page",
      name: "OrderPage",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/order/Page.vue"),
      meta: {
        title: "订单管理",
        showNavBar: true,
      },
    },
    {
      path: "/order/detail",
      name: "OrderDetail",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/order/Detail.vue"),
      meta: {
        title: "订单详情",
        showNavBar: false,
      },
    },
    {
      path: "/order/log",
      name: "OrderLog",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/order/OrderLog.vue"),
      meta: {
        title: "订单日志",
        showNavBar: false,
      },
    },
    {
      path: "/order/roomInfo",
      name: "OrderRoomInfo",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/order/checkIn/RoomInfo.vue"),
      meta: {
        title: "排房信息",
        showNavBar: false,
      },
    },
    {
      path: "/order/checkIn",
      name: "OrderCheckIn",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/order/checkIn/CheckIn.vue"),
      meta: {
        title: "办理入住",
        showNavBar: false,
      },
    },
    {
      path: "/order/checkOut",
      name: "OrderCheckOut",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/order/CheckOut.vue"),
      meta: {
        title: "办理退房",
        showNavBar: false,
      },
    },
    {
      path: "/order/cashDesk",
      name: "OrderCashDesk",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/order/CashDesk.vue"),
      meta: {
        title: "收银台",
        showNavBar: false,
      },
    },
    {
      path: "/order/inAccount",
      name: "OrderInAccount",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/order/InAccount.vue"),
      meta: {
        title: "入账",
        showNavBar: false,
      },
    },
    {
      path: "/order/addRoomCost",
      name: "OrderAddRoomCost",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/order/AddRoomCost.vue"),
      meta: {
        title: "加收房费",
        showNavBar: false,
      },
    },
    {
      path: "/order/UnitRoom",
      name: "UnitRoom",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/order/UnitRoom.vue"),
      meta: {
        title: "联房",
        showNavBar: false,
      },
    },
    {
      path: "/order/SplitRoom",
      name: "SplitRoom",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/order/SplitRoom.vue"),
      meta: {
        title: "拆联",
        showNavBar: false,
      },
    },
  ],
};
